import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Chart, ChartOptions } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

    constructor(
        private http: HttpService,
        public loading: LoadingService,
        private modalService: NgbModal
    ) {
        // Chart.register(ChartDataLabels);
    }
    @ViewChild('calendarModal') calendarModal!: any;
    @ViewChild('pointChart') pointChart!: ElementRef;
    @ViewChild('timeChart') timeChart!: ElementRef;
    private apiPath = 'dashboard';
    quizFilter: any = 'WPPSI';
    data: any = {};
    date_range: any = { start: moment().subtract(29, 'days'), end: moment() };
    selectedDate: string = this.date_range.start.format('DD MMM YY') + ' - ' + this.date_range.end.format('DD MMM YY');
    query: any = {
        from: this.date_range.start.format('YYYY-MM-DD'),
        to: this.date_range.end.format('YYYY-MM-DD'),
        quiz: this.quizFilter
    };
    ranges: any = {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
    };
    calendarDialog: any = {
        modal: null,
        show: () => {
            this.calendarDialog.modal = this.modalService.open(this.calendarModal, { keyboard: false, backdrop: 'static', centered: true, size: 'lg', windowClass: 'modal-transparent' });
        },
        submit: (ev: any) => {
            this.date_range.start = ev.startDate;
            this.date_range.end = ev.endDate;
            this.selectedDate = ev.startDate.format('DD MMM YY') + ' - ' + ev.endDate.format('DD MMM YY');
            this.query.from = ev.startDate.format('YYYY-MM-DD');
            this.query.to = ev.endDate.format('YYYY-MM-DD');
            this.calendarDialog.modal.close();
            this.getData();
        },
        cancel: () => {
            this.calendarDialog.modal.close();
            this.date_range = { start: moment().subtract(29, 'days'), end: moment() };
            this.selectedDate = this.date_range.start.format('DD MMM YY') + ' - ' + this.date_range.end.format('DD MMM YY');
            this.query.from = this.date_range.start.format('YYYY-MM-DD');
            this.query.to = this.date_range.end.format('YYYY-MM-DD');
            this.getData();
        }
    };
    chart_options: ChartOptions | any = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'right',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                }
            },
            // datalabels: {
            //     display: true,
            //     align: 'center',
            //     anchor: 'center',
            //     formatter: (value: string | number) => {
            //         if (value > 0) {
            //             value = value.toString();
            //             let _value: any = value.split(/(?=(?:...)*$)/);
            //             _value = _value.join(',');
            //             return _value;
            //         } else {
            //             value = "";
            //             return value;
            //         }

            //     }
            // }
        }
    };
    chart_point: Chart | undefined;
    chart_time: Chart | undefined;

    getData(): void {
        this.http.Get(this.apiPath, this.query).then((r: any) => {
            if (r.success) {
                this.data = r?.response?.result || {};
                this.chart_point?.destroy();
                let point_data: any = {
                    labels: [],
                    datasets: [
                        {
                            type: 'bar',
                            label: 'Mean',
                            data: []
                        },
                        {
                            type: 'line',
                            label: 'Median',
                            data: []
                        }
                    ]
                };
                (this.data.point || []).forEach((e: any) => {
                    point_data.labels.push(e.name);
                    point_data.datasets[0].data.push(e.mean);
                    point_data.datasets[1].data.push(e.median);
                });
                this.chart_point = new Chart(this.pointChart?.nativeElement, {
                    data: point_data,
                    options: this.chart_options
                });

                this.chart_time?.destroy();
                let time_data: any = {
                    labels: [],
                    datasets: [
                        {
                            type: 'bar',
                            label: 'Mean',
                            data: []
                        },
                        {
                            type: 'line',
                            label: 'Median',
                            data: []
                        }
                    ]
                };
                (this.data.time || []).forEach((e: any) => {
                    time_data.labels.push(e.name);
                    time_data.datasets[0].data.push(e.mean);
                    time_data.datasets[1].data.push(e.median);
                });
                let cOptions = JSON.parse(JSON.stringify(this.chart_options));
                cOptions.scales = {
                    y: {
                        ticks: {
                            callback: (v: any) => this.secondToTime(v)
                        }
                    }
                };
                // cOptions.plugins.datalabels = {
                //     display: true,
                //     align: 'center',
                //     anchor: 'center',
                //     formatter: (v: string | number) => this.secondToTime(Number(v || '0'))
                // };
                cOptions.plugins.tooltip = {
                    callbacks: {
                        label: (context: any) => {
                            let label = context.dataset.label || '';

                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += this.secondToTime(Number(context.parsed.y || '0'));
                            }
                            return label;
                        }
                    }
                };
                this.chart_time = new Chart(this.timeChart?.nativeElement, {
                    data: time_data,
                    options: cOptions
                });
            }
        });
    }

    secondToTime(s: number): string {
        let date = new Date(0);
        date.setSeconds(s);
        return date.toISOString().substring(11, 19);
    }

    ngOnInit(): void {
        this.getData();
    }

}
